import api from '@/api';
import {
  CouponCompanyConfig,
  CouponCompanyConfigCreateRequest,
  CouponCompanyPartConfig,
  CouponCompanyPartConfigRequest,
  CouponCompanyTaskConfig,
  CouponCompanyTaskConfigRequest,
  CouponEquipment,
  CouponEquipmentCreate,
  CouponEquipmentEdit,
  CouponEquipmentRemoveParams,
} from './company.types';

const CONTROLLER_URL = `/coupon/companies`;

export const couponEquipmentServices = {
  async list(companyId?: number) {
    const result = (await api.get(
      `${CONTROLLER_URL}/${companyId}/equipments`,
      null,
    )) as unknown;
    return result as CouponEquipment[];
  },

  async create({ companyId, ...data }: CouponEquipmentCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/${companyId}/equipments`,
      data,
    )) as unknown;
    return result as CouponEquipment;
  },

  async edit({ companyId, id, ...data }: CouponEquipmentEdit) {
    const result = (await api.put(
      `${CONTROLLER_URL}/${companyId}/equipments/${id}`,
      { ...data },
      null,
    )) as unknown;
    return result as CouponEquipment;
  },

  async remove(data: CouponEquipmentRemoveParams) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/${data.companyId}/equipments/${data.equipmentId}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async configDetail(companyId?: number) {
    const result = (await api.get(
      `${CONTROLLER_URL}/${companyId}/configs`,
      null,
    )) as unknown;
    return result as CouponCompanyConfig;
  },

  async configCreate({ companyId, ...data }: CouponCompanyConfigCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/${companyId}/configs`,
      data,
    )) as unknown;
    return result as CouponCompanyConfig;
  },

  async configEnable(companyId: number) {
    const result = (await api.patch(
      `${CONTROLLER_URL}/${companyId}/configs/enable`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async configDisable(companyId: number) {
    const result = (await api.patch(
      `${CONTROLLER_URL}/${companyId}/configs/disable`,
      {},
      null,
    )) as unknown;
    return result as void;
  },

  async configPart({ companyId, ...data }: CouponCompanyPartConfigRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/${companyId}/configs/part`,
      data,
    )) as unknown;
    return result as CouponCompanyPartConfig['defaultTaxConfig'];
  },

  async configTask({ companyId, ...data }: CouponCompanyTaskConfigRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/${companyId}/configs/task`,
      data,
    )) as unknown;
    return result as CouponCompanyTaskConfig['defaultTaxConfig'];
  },
};
